// Libs
import { useContext } from "react";
import "./HeaderComponent.scss";

// Import App Context
import {
    AppContext,
} from "../../../contexts/AppContext";

// Header Logos
import LogoLeft from "../../../assets/header-logos/ilportaledell'automobilista.png";
import LogoRight from "../../../assets/header-logos/ministerodeitrasporti.png";


const HeaderComponent = () => {
    // Inheritance
    const { appText } = useContext(AppContext);
    const {  REVISIONI_TEXT } = appText;


    return (
        <header className="HeaderComponent">
            <div className="TopHeader">
                <div className="container">
                    <div className="row TopHeader__row">
                        <a href={REVISIONI_TEXT.HEADER_PORTALE_AUTOMOBILISTA_URL} className="TopHeader__link">
                            <img src={LogoLeft} alt="logo-left" className="TopHeader__image"/>
                        </a>
                        <a href={REVISIONI_TEXT.HEADER_MINISTERO_TRASPORTI_URL} className="TopHeader__link">
                            <img src={LogoRight} alt="logo-right" className="TopHeader__image"/>
                        </a>
                    </div>
                </div>
            </div>
            <div className="PrimaryHeader ">
                <div className="container">
                    <nav className="PrimaryHeader__nav">
                        <div className="PrimaryHeader__title">
                            {REVISIONI_TEXT.HEADER_PAGE_TITLE}
                        </div>
                        <a href={REVISIONI_TEXT.HEADER_PORTALE_AUTOMOBILISTA_URL} className="PrimaryHeader__button btn btn-primary">
                            <i className="bi bi-box-arrow-in-right customIcon" ></i> 
                            <span className={"customText "} >{REVISIONI_TEXT.HEADER_BUTTON_TITLE}</span>
                        </a>
                        
                    </nav>
                </div>
            </div>

            
        </header>
    );
};

export default HeaderComponent;
